// extracted by mini-css-extract-plugin
export default {"title":"LSj_eDMl"};